const state = {
    
}

const getters = {
    
}

const mutations = {
    
}

const actions = {
    login({ dispatch }, params) {
        return dispatch('apiAuth/login', { 
            partCard1: params.partCard1 || '000', 
            partCard2: params.partCard2 || '000000', 
            partCard3: params.partCard3 || '000', 
            customerNip: params.customerNip || '0000000000' 
        }, { root: true })
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}